import classNames from 'classnames'
import styles from '@/components/Header/Header.module.scss'
import useHeaderGuides from '@hooks/header/notifications/useHeaderGuides'
import {useEffect, useState} from 'react'
import dayjs from 'dayjs'

const GuidesTab = () => {
  const [guidesList, setGuidesList] = useState<any[]>([])
  const {headerGuidesData} = useHeaderGuides()

  useEffect(() => {
    if (headerGuidesData.length > 0) {
      setGuidesList(headerGuidesData)
    }
  }, [headerGuidesData])

  return (
    <div className={classNames([styles.tabContentWrapper, 'tabGuide'])}>
      <a href="https://hotro.onlive.vn/index.php?pt=notice_list" target="_blank" className={styles.btnSeemore}>Xem thêm</a>
      <div className={styles.guidesList}>
        {guidesList.length > 0 && guidesList.map((item) => {
          const guideTime = dayjs(item?.i_reg_date).format('HH:mm:ss')
          const guideDate = dayjs(item?.i_reg_date).format('DD/MM/YYYY')
          return (
            <a key={item?.i_no} href={item?.i_link_url} className={styles.guideItem} target="_blank">
              <span className={styles.guideTitle}>{item?.i_title}</span>
              <span className={styles.guideTime}>{guideTime} - {guideDate}</span>
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default GuidesTab
